import React from 'react';
import { IconProps } from '../../types/icon';

const CsvIcon: React.FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <img
      src="/gitex-illustrations/CsvIcon.png"
      alt="CSV Spreadsheet"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default CsvIcon;